import { Box } from "@chakra-ui/react";
import { colors } from "../";
import { HStack } from "./HStack";

interface StepIndicatorProps {
  totalSteps: number;
  currentStep: number;
}

export const StepIndicator = ({
  totalSteps,
  currentStep,
}: StepIndicatorProps) => {
  return (
    <HStack width="100%" alignItems="center" justifyContent="center" gap={8}>
      {Array.from({ length: totalSteps }).map((_, index) => {
        return (
          <Box
            key={index}
            width="8px"
            height="8px"
            borderRadius="50%"
            backgroundColor={
              currentStep === index + 1 ? colors.gray900 : colors.gray200
            }
          />
        );
      })}
    </HStack>
  );
};
